import { render, staticRenderFns } from "./SubpageNotificationOverview.vue?vue&type=template&id=3534886c&"
import script from "./SubpageNotificationOverview.vue?vue&type=script&lang=js&"
export * from "./SubpageNotificationOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3534886c')) {
      api.createRecord('3534886c', component.options)
    } else {
      api.reload('3534886c', component.options)
    }
    module.hot.accept("./SubpageNotificationOverview.vue?vue&type=template&id=3534886c&", function () {
      api.rerender('3534886c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/notifications/SubpageNotificationOverview.vue"
export default component.exports